"use strict";
// CustomEvent
/* tslint:disable */
(function () {
    // @ts-ignore;
    if (typeof window.CustomEvent === 'function') {
        return false;
    }
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    // @ts-ignore;
    CustomEvent.prototype = window.Event.prototype;
    // @ts-ignore;
    window.CustomEvent = CustomEvent;
})();
Array.prototype.find ||
    Object.defineProperty(Array.prototype, 'find', {
        value: function (r) {
            if (null == this)
                throw new TypeError('"this" is null or not defined');
            var e = Object(this), t = e.length >>> 0;
            if ('function' != typeof r)
                throw new TypeError('predicate must be a function');
            for (var n = arguments[1], i = 0; i < t;) {
                var o = e[i];
                if (r.call(n, o, i, e))
                    return o;
                i++;
            }
        },
        configurable: !0,
        writable: !0,
    });
Array.prototype.findIndex ||
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (r) {
            if (null == this)
                throw new TypeError('"this" is null or not defined');
            var e = Object(this), t = e.length >>> 0;
            if ('function' != typeof r)
                throw new TypeError('predicate must be a function');
            for (var n = arguments[1], i = 0; i < t;) {
                var o = e[i];
                if (r.call(n, o, i, e))
                    return i;
                i++;
            }
            return -1;
        },
        configurable: !0,
        writable: !0,
    });
